import { ApplicationType } from '@wix/editor-application';
const isAddon = component => {
  return component.type === ApplicationType.EditorAddon;
};
export class AddonsExtractor {
  extract(app) {
    const appDefinitionId = app.appDefinitionId;
    if (!app.components || !appDefinitionId) {
      return [];
    }
    const addons = [];
    const components = app.components;
    for (const component of components) {
      if (!isAddon(component)) {
        continue;
      }
      const {
        editorScript,
        toolPanelConfig
      } = component.data || {};
      const addon = {
        appDefinitionId,
        appDefinitionName: app.appDefinitionName || 'Unknown addon',
        type: ApplicationType.EditorAddon,
        data: {
          toolPanelConfig: {
            ...toolPanelConfig,
            initialPosition: {
              // @ts-expect-error wrong types in DM
              x: '200',
              // @ts-expect-error wrong types in DM
              y: '200',
              ...toolPanelConfig.initialPosition
            }
          }
        }
      };
      if (editorScript) {
        addon.url = editorScript;
      }
      addons.push(addon);
    }
    return addons;
  }
}
//# sourceMappingURL=AddonsExtractor.js.map